import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import es from './locales/es.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';

export const SUPPORTED_LANGUAGES = ['ru', 'en', 'zh', 'es'] as const;
export type UiLanguage = (typeof SUPPORTED_LANGUAGES)[number];
export const DEFAULT_LANGUAGE: UiLanguage = 'ru';
export const LANGUAGE_STORAGE_KEY = 'speakmanager.language';

export const resources = {
  ru: { translation: ru },
  en: { translation: en },
  zh: { translation: zh },
  es: { translation: es },
};

export function normalizeLanguage(value: string | null | undefined): UiLanguage {
  const short = (value ?? '').toLowerCase().split(/[-_]/)[0];
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(short) ? (short as UiLanguage) : DEFAULT_LANGUAGE;
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: DEFAULT_LANGUAGE,
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ['localStorage'],
    },
  });

i18n.on('languageChanged', (lng) => {
  if (typeof document !== 'undefined') document.documentElement.lang = normalizeLanguage(lng);
});

export default i18n;
